const useIsIOSDevice = () => {
  return (
    /iP(ad|hone|od)/.test(window?.navigator?.platform) ||
    (window?.navigator?.platform === "MacIntel" &&
      window?.navigator?.maxTouchPoints > 1)
  );
};

export default useIsIOSDevice;
